module.exports = new __parcel__URL__("Start.bdc603a2.webp").toString();